/**
 * The calendar events store loads calendar events based on calendar folder ids,
 * In order for owa-calendar-events-loader to communicate with the events store
 * it needs to convert the consumer input data (i.e. calendar ids) to folder ids.
 * This type is then used by getFolderIds and updateFolderIdsInCalendarCache to get and update the
 * the folders needed to communicate with the events store.
 */

export enum GetFolderIdsDataType {
    CalendarIds,
    DefaultCalendar,
}

export interface CalendarIdsGetFolderIdsData {
    calendarIds: string[];
    loaderType: GetFolderIdsDataType.CalendarIds;
}

export interface DefaultGetFolderIdsData {
    loaderType: GetFolderIdsDataType.DefaultCalendar;
}

export type GetFolderIdsData = DefaultGetFolderIdsData | CalendarIdsGetFolderIdsData;
